import { createListenerMiddleware, isAnyOf } from "@reduxjs/toolkit";
import {
  toggleCalendar,
  setCalendarActive,
  setAllCalendarsActive,
  initializeCalendars,
} from "./calendarPreferencesSlice";
import { calendarService } from "../../services/almanac";
import type { RootState } from "../../store";
import type { CalendarPreferences } from "./calendarPreferencesSlice";

const STORAGE_KEY = "calendarPreferences";

const saveToLocalStorage = (state: CalendarPreferences) => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
  } catch (error) {
    console.warn("Failed to save calendar preferences to localStorage:", error);
  }
};

export const calendarPreferencesListener = createListenerMiddleware();

// Listen for calendar preference changes and save to localStorage
calendarPreferencesListener.startListening({
  matcher: isAnyOf(
    toggleCalendar,
    setCalendarActive,
    setAllCalendarsActive,
    initializeCalendars,
  ),
  effect: async (_action, listenerApi) => {
    // Wait for the state to be updated
    await listenerApi.delay(0);

    // Get the current state
    const state = listenerApi.getState() as RootState;
    const calendarPreferences = state.calendarPreferences;

    // Save to localStorage
    saveToLocalStorage(calendarPreferences);
  },
});

// Listen for calendar service data changes and auto-initialize preferences
calendarPreferencesListener.startListening({
  matcher: calendarService.endpoints.getCalendar.matchFulfilled,
  effect: (action, listenerApi) => {
    const calendars = action.payload;

    if (calendars && calendars.length > 0) {
      const calendarIds = calendars.map((calendar) => calendar.id);

      // Dispatch initialize action
      listenerApi.dispatch(initializeCalendars(calendarIds));
    }
  },
});
